export default __webpack_public_path__ + "static/media/stripe.f4d77043.png";